import * as Sentry from "@sentry/react";
import { isAxiosError } from "axios";
import { enqueueSnackbar } from "notistack";

/**
 * Wraps a promise: snackbar + Sentry on failure, then rethrows (React Query must see rejection).
 */
export async function handleNetworkError<T>(
    promise: Promise<T>,
    fallbackMessage = "Görev oluşturulamadı."
): Promise<T> {
    try {
        return await promise;
    } catch (e) {
        const message = isAxiosError(e)
            ? ((e.response?.data as { message?: string } | undefined)?.message ?? fallbackMessage)
            : fallbackMessage;

        enqueueSnackbar(message, { variant: "error" });
        console.error(e);
        Sentry.captureException(e);

        throw e;
    }
}
